import { lazy } from 'react'

// project import
import {LinearLoadable} from 'components/Loadables';
import { 
    reservationRoutes,
    frontdeskRoutes,
    backtrackRoutes,
    houseKeepingRoutes,
    mainBarRoutes,
    poolBarRoutes,
    recordsRoutes,
    restaurantRoutes,
    // roomserviceRoutes,
    settingsRoutes,
    storeRoutes,
    statisticsRoutes,
    accountsRoutes
} from './routeDiary';

// render - sample page
const Modules = LinearLoadable(lazy(() => import('pages/Modules')));

export const routeChildrenCreator = (rouuteModuleList: string[]) => { 
    const routeChildren = []as any[];
    rouuteModuleList.forEach(route => {
        const data = {
            path: route,
            element: <Modules />
        };
        routeChildren.push(data)
    });
    return routeChildren;
}

// ==============================|| Route Children ||============================== //
export const reservationsRouteChildren = routeChildrenCreator(reservationRoutes);
export const frondeskRouteChildren = routeChildrenCreator(frontdeskRoutes);
export const houseKeepingRouteChildren = routeChildrenCreator(houseKeepingRoutes);
export const mainBarRouteChildren = routeChildrenCreator(mainBarRoutes);
export const poolBarRouteChildren = routeChildrenCreator(poolBarRoutes);
export const restaurantRouteChildren = routeChildrenCreator(restaurantRoutes);
export const storeRouteChildren = routeChildrenCreator(storeRoutes);
export const recordsRouteChildren = routeChildrenCreator(recordsRoutes);
export const backtrackRouteChildren = routeChildrenCreator(backtrackRoutes);
export const settingsRouteChildren = routeChildrenCreator(settingsRoutes);
export const statisticsRouteChildren = routeChildrenCreator(statisticsRoutes);
export const accountsRouteChildren = routeChildrenCreator(accountsRoutes);

